import React from 'react';
import { Modal, Button, Group, Text, Stack, Divider } from '@mantine/core';
import logoUrl from '/assets/NEW WCWD LOGO BLACK.svg';

/**
 * Reusable login modal component that directs users to your existing login page
 *
 * @param {Object} props - Component props
 * @param {boolean} props.opened - Whether the modal is open
 * @param {function} props.onClose - Function to call when modal closes
 * @param {string} props.returnPath - Path to return to after login (defaults to current path)
 * @param {string} props.actionText - Custom text explaining the action (e.g. "to subscribe")
 * @param {string} props.entityName - Name of entity user is interacting with (optional)
 */
const LoginModal = ({
  opened,
  onClose,
  returnPath = window.location.pathname,
  actionText = 'to continue',
  entityName = '',
}) => {
  console.log('returnPath:', returnPath);

  return (
    <Modal opened={opened} onClose={onClose} title="Login Required" centered size="sm">
      <Stack gap="md" align="center">
        <img
          src={logoUrl}
          alt="Logo"
          style={{
            display: 'block',
            margin: '0 auto',
            width: '150px',
            height: 'auto',
          }}
        />

        <Text size="md" align="center">
          You need to be logged in {actionText}
          {entityName ? ` to ${entityName}` : ''}.
        </Text>

        <Group gap="center" grow style={{ width: '100%' }}>
          <Button component="a" href={`/login?return_to=${returnPath}`} color="#EA580C" size="lg" fullWidth>
            Log in
          </Button>
        </Group>

        <Group gap="center" grow style={{ width: '100%' }}>
          <Button
            component="a"
            href={`/register?return_to=${returnPath}`}
            variant="outline"
            color="#EA580C"
            size="lg"
            fullWidth
          >
            Sign up
          </Button>
        </Group>

        {/* <Divider label="Or" labelPosition="center" style={{ width: '100%' }} /> */}
      </Stack>
    </Modal>
  );
};

export default LoginModal;
